import { Link } from 'react-router-dom';

function Privacy() {
  return (
    <div className="page" style={{ paddingBottom: '40px' }}>
      <div className="page-header">
        <Link to="/" className="landing-link" style={{ fontSize: '14px' }}>&larr; Back</Link>
        <h1 className="page-title" style={{ fontSize: '32px', marginTop: '8px' }}>Privacy Policy</h1>
        <p className="text-muted" style={{ marginTop: '4px' }}>Last updated: February 2026</p>
      </div>

      <div className="container">
        <div className="card" style={{ background: 'white', border: '1px solid #E8D9C8' }}>
          <h3 style={{ margin: '0 0 8px', color: '#4A2E1F' }}>What we collect</h3>
          <p style={{ color: '#7A5A44', lineHeight: 1.6, margin: '0 0 20px' }}>
            When you use Tract, we collect and store the following data tied to your account:
          </p>
          <ul style={{ color: '#7A5A44', lineHeight: 1.8, margin: '0 0 20px', paddingLeft: '20px' }}>
            <li>Your email address (for login)</li>
            <li>Photos of meals you upload</li>
            <li>AI-extracted food names and ingredients</li>
            <li>Bowel movement logs (timestamps and severity)</li>
            <li>AI-generated correlation insights</li>
          </ul>

          <h3 style={{ margin: '0 0 8px', color: '#4A2E1F' }}>How we use it</h3>
          <p style={{ color: '#7A5A44', lineHeight: 1.6, margin: '0 0 20px' }}>
            Your data is used solely to provide the Tract service — analyzing meals, logging symptoms, and identifying potential food triggers. We do not sell, share, or monetize your personal health data.
          </p>

          <h3 style={{ margin: '0 0 8px', color: '#4A2E1F' }}>AI processing</h3>
          <p style={{ color: '#7A5A44', lineHeight: 1.6, margin: '0 0 20px' }}>
            Meal photos and logged data are sent to third-party AI providers (OpenAI and/or Anthropic) for food identification and correlation analysis. These providers process your data according to their respective privacy policies and do not use it to train models.
          </p>

          <h3 style={{ margin: '0 0 8px', color: '#4A2E1F' }}>Data storage</h3>
          <p style={{ color: '#7A5A44', lineHeight: 1.6, margin: '0 0 20px' }}>
            Your data is stored on secure servers. Passwords are hashed using bcrypt and are never stored in plain text. You can request deletion of your account and all associated data at any time by contacting us.
          </p>

          <h3 style={{ margin: '0 0 8px', color: '#4A2E1F' }}>Not medical advice</h3>
          <p style={{ color: '#7A5A44', lineHeight: 1.6, margin: '0 0 20px' }}>
            Tract is a tracking tool, not a medical device. Insights generated by AI are suggestions based on patterns in your data and should not be treated as medical diagnoses or advice. Always consult a healthcare professional for medical concerns.
          </p>

          <h3 style={{ margin: '0 0 8px', color: '#4A2E1F' }}>Contact</h3>
          <p style={{ color: '#7A5A44', lineHeight: 1.6, margin: 0 }}>
            Questions about your data? Reach us at{' '}
            <a href="mailto:support@tractapp.ai" className="landing-link">
              support@tractapp.ai
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
